import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=9ce65130&scoped=true&"
import script from "./PageNotFound.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PageNotFound.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=9ce65130&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce65130",
  null
  
)

export default component.exports